export enum StatsFiltersTitle {
  ReturnsFrom = 'Returns From',
}
